module.exports = __webpack_public_path__ + "img/knot-right.a1c49313.svg";